import BaseStorage from './auth-token-base'
import Cookies from './../../cookies'

/**
 * @class
 * @implements {BaseStorage}
 */
class CookiesStorage extends BaseStorage {
  Write (token) {
    new Cookies().set(super.tokenPath, token)
  }
  Read () {
    return new Cookies().get(super.tokenPath)
  }
  Remove () {
    new Cookies().delete(super.tokenPath)
  }
}

export default CookiesStorage



// WEBPACK FOOTER //
// ./src/common/auth/storage/auth-token-cookies.js